import React, { SyntheticEvent, useContext, useEffect, useState } from "react";
import { Tab, Stack } from "@mui/material";
import { Routes, Route, useNavigate } from "react-router-dom";
import { StyledBox, StyledTabs, StyledHeader } from "./Measurements.styled";
import List from "../List/List";
import Thresholds from "../Thresholds/Thresholds";
import Chart from "../Chart/Chart";
import Attributes from "../Attributes/Attributes";
import { GlobalContext } from "context/Provider";
import { useTranslation } from "react-i18next";

interface MeasurementProps {
  type: string;
}

export default function Measurements({type}: MeasurementProps) {
  const memberId = window.location.pathname.split("/").pop();
  const [tabValue, setTabValue] = useState("list/" + memberId);
  const { member, config, settings } = useContext(GlobalContext);
  const navigate = useNavigate();
  const { t } = useTranslation();

  const chartSettings = settings?.member?.data?.system?.settings?.chartOptions;

  function typeToSettingKey(type: string) {
    switch (type) {
      case "Blood Pressure":
        return "bloodPressure";
      case "Blood Glucose":
        return "bloodGlucose";
      case "Heart Rate":
        return "heartRate";
      case "Oxygen Saturation":
        return "oxygenSaturation";
      case "Temperature":
        return "temperature";
      case "Weight":
        return "weight";
      case "activity":
        return "activity";
      case "Sleep":
        return "sleep";
      case "Respiration Rate":
        return "respirationRate";
      case "Member Note":
        return "memberNotes";
      case "Spirometry":
        return "spirometry";
      default:
        return "";
    }
  }

  const showChartTab = (() => {
    if (!chartSettings) return false;
    const key = typeToSettingKey(type);
    return chartSettings?.[key];
  })();

  const changeTab = (event: SyntheticEvent, newValue: string) => {
    let currentPath = window.location.pathname.split("/");
    if (currentPath.length > 5) {
      // remove memberId & current tab before navigating to the next
      currentPath.pop();
      currentPath.pop();
    }
    navigate(`${currentPath.join("/")}/${newValue}`);
    setTabValue(newValue);
  };

  useEffect(() => {
    window.location.pathname.split("/")[4] === "details"
      ? setTabValue("list" + "/" + memberId)
      : setTabValue(window.location.pathname.split("/")[4] + "/" + memberId);
  }, [window.location.pathname.split("/")[3]]);
  return (
    <Stack>
      <StyledBox>
        <StyledHeader>
          {t(`u-${type.toLowerCase().replace(" ", "-")}`)}
        </StyledHeader>
        <StyledTabs value={tabValue} onChange={changeTab}>
          <Tab value={`list/${member?.current.id}`} label={t("u-list")} />
          {showChartTab && (
            <Tab value={`chart/${member?.current.id}`} label={t("u-chart")} />
          )}
          <Tab
            value={`thresholds/${member?.current.id}`}
            label={t("u-thresholds")}
          />
        </StyledTabs>
      </StyledBox>
      <Routes>
        <Route path=":readingId/:memberId" element={<Attributes
            type={type}
            memberId={memberId ?? ""}
        />} />
        <Route path="list/:memberId" element={<List type={type}/>} />
        {showChartTab && (
          <Route path="chart/:memberId" element={<Chart
              type={type}
              memberId={memberId ?? ""}
          />} />
          )}
        <Route
          path="thresholds/:memberId"
          element={<Thresholds type={type}/>}
        />
      </Routes>
    </Stack>
  );
}
